import React from "react";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { Theme, useThemed } from "../../hooks/useTheme";
import { graphql, useStaticQuery } from "gatsby";

export const TestimonialsTopCta = (props: {
  className?: string;
  theme?: Theme;
  relativeLink?: boolean;
}) => {
  const { t } = useTranslation();
  const themed = useThemed(props.theme);

  const {
    allTestimonialsJson: { nodes: testimonials },
  } = useStaticQuery<{
    allTestimonialsJson: {
      nodes: {
        name: string;
        role: string;
        company: string;
        image: string;
        comment: {
          it: string;
          en: string;
          de: string;
        };
      }[];
    };
  }>(graphql`
    query TestimonialsForCta {
      allTestimonialsJson(limit: 3) {
        nodes {
          image
        }
      }
    }
  `);

  return (
    <a href={props.relativeLink === true ? "#testimonials" : "/#testimonials"}>
      <div
        className={twMerge(
          "max-w-fit flex flex-no-wrap items-center justify-center p-0.5 pr-1 rounded-full border text-sm",
          props.className,
          themed({
            white: "bg-white text-primary border-primary dark:bg-gray-900",
            gray: "bg-white text-primary border-primary dark:bg-gray-800",
            indigo: "bg-indigo-600 text-white",
            dark: "bg-indigo-300 text-indigo-900 border-indigo-500",
          }),
        )}
      >
        <div className="flex items-center">
          {testimonials.map((testimonial, index) => (
            <img
              key={index}
              className={twMerge(
                "h-6 w-6 rounded-full border-2 border-white",
                themed({
                  white: "border-white dark:border-gray-900",
                  gray: "border-white dark:border-gray-800",
                  indigo: "border-indigo-600",
                  dark: "border-indigo-300",
                }),
                index === 1 && "-translate-x-2",
                index === 2 && "-translate-x-4",
              )}
              src={
                require(`../../assets/images/testimonials/${testimonial.image}`)
                  .default
              }
              alt={`userImage${index + 1}`}
            />
          ))}
        </div>
        <p className=" -translate-x-2 font-bold whitespace-nowrap">
          {t("common:testimonialsTopCta")}
        </p>
      </div>
    </a>
  );
};
